<div class="min-h-screen flex items-center justify-center bg-[hsl(210_20%_98%)] px-4 py-10">
  <div class="w-full max-w-sm space-y-8">
    <div class="text-center">
      <a routerLink="/" class="inline-block">
        <img src="/images/attestio-logo.png" alt="Attestio" class="h-10 mx-auto mb-6" />
      </a>

      @if (view() === 'login') {
        <h1 class="font-display text-2xl font-bold text-[hsl(213_55%_15%)]">
          Se connecter
        </h1>
        <p class="text-sm text-[hsl(213_15%_46%)] mt-2">
          Accédez à votre espace sécurisé
        </p>
      } @else if (view() === 'forgotPassword') {
        <h1 class="font-display text-2xl font-bold text-[hsl(213_55%_15%)]">
          Mot de passe oublié
        </h1>
        <p class="text-sm text-[hsl(213_15%_46%)] mt-2">
          Entrez votre adresse e-mail pour recevoir un lien de réinitialisation
        </p>
      } @else {
        <h1 class="font-display text-2xl font-bold text-[hsl(213_55%_15%)]">
          Identifiant oublié
        </h1>
        <p class="text-sm text-[hsl(213_15%_46%)] mt-2">
          Entrez l’adresse e-mail de votre compte : nous vous enverrons un rappel si elle est reconnue
        </p>
      }
    </div>

    @if (view() === 'emailNotVerified') {
      <div class="space-y-4">
        <div class="rounded-xl border border-amber-200 bg-amber-50 p-5 space-y-3">
          <div class="flex items-center gap-2">
            <span class="material-symbols-outlined text-amber-600">mark_email_unread</span>
            <h2 class="font-semibold text-amber-900">Vérifiez votre e-mail</h2>
          </div>
          <p class="text-sm text-amber-800">
            Votre adresse e-mail n'a pas encore été vérifiée. Consultez votre boîte de réception et cliquez sur le lien de vérification.
          </p>
          <p class="text-xs text-amber-700">
            Si vous ne trouvez pas l'e-mail, <b>vérifiez vos spams</b> ou cliquez ci-dessous pour en recevoir un nouveau.
          </p>
        </div>
        <button
          type="button"
          class="w-full h-11 rounded-lg bg-secondary text-white font-semibold cursor-pointer
                 hover:bg-secondary-hover transition-colors duration-150 disabled:opacity-60 disabled:cursor-not-allowed"
          [disabled]="resendingVerification()"
          (click)="resendVerification()"
        >
          @if (resendingVerification()) {
            Envoi en cours…
          } @else {
            Renvoyer le lien de vérification
          }
        </button>
        <div class="text-center">
          <button type="button" class="cursor-pointer text-secondary text-sm font-medium hover:underline" (click)="setView('login')">
            Retour à la connexion
          </button>
        </div>
      </div>
    } @else if (view() === 'login') {
      <form (ngSubmit)="login()" class="space-y-4" autocomplete="on">
        <div>
          <label class="sr-only" for="login-email">Email</label>
          <input
            id="login-email"
            type="email"
            placeholder="Email"
            class="h-11 w-full rounded-lg border border-[hsl(210_20%_90%)] bg-white px-3 text-[hsl(213_55%_15%)]
                   placeholder:text-[hsl(213_15%_46%)]
                   focus:border-secondary focus:outline-none focus:ring-2 focus:ring-secondary/25"
            [value]="email()"
            (input)="email.set($any($event.target).value)"
            required
            autocomplete="email"
          />
        </div>

        <div>
          <label class="sr-only" for="login-password">Mot de passe</label>
          <input
            id="login-password"
            type="password"
            placeholder="Mot de passe"
            class="h-11 w-full rounded-lg border border-[hsl(210_20%_90%)] bg-white px-3 text-[hsl(213_55%_15%)]
                   placeholder:text-[hsl(213_15%_46%)]
                   focus:border-secondary focus:outline-none focus:ring-2 focus:ring-secondary/25"
            [value]="password()"
            (input)="password.set($any($event.target).value)"
            required
            autocomplete="current-password"
          />
        </div>

        <div class="flex flex-col items-end gap-1 text-sm">
          <button type="button" class="text-secondary cursor-pointer hover:underline" (click)="setView('forgotPassword')">
            Mot de passe oublié ?
          </button>
        </div>

        @if (errorMessage().length > 0) {
          <p class="text-sm text-red-600 text-center">{{ errorMessage() }}</p>
        }

        <button
          type="submit"
          class="w-full h-11 rounded-lg bg-secondary text-secondary-foreground font-semibold cursor-pointer
                 hover:bg-secondary-hover transition-colors duration-150 disabled:opacity-60 disabled:cursor-not-allowed"
          [disabled]="!isLoginFormValid() || loading()"
        >
          @if (loading()) {
            Chargement…
          } @else {
            Se connecter
          }
        </button>
      </form>
    } @else {
      <form (ngSubmit)="submitRecovery()" class="space-y-4">
        <div>
          <label class="sr-only" for="recovery-email">Email</label>
          <input
            id="recovery-email"
            type="email"
            placeholder="Email"
            class="h-11 w-full rounded-lg border border-[hsl(210_20%_90%)] bg-white px-3 text-[hsl(213_55%_15%)]
                   placeholder:text-[hsl(213_15%_46%)]
                   focus:border-secondary focus:outline-none focus:ring-2 focus:ring-secondary/25"
            [value]="email()"
            (input)="email.set($any($event.target).value)"
            required
            autocomplete="email"
          />
        </div>

        @if (errorMessage().length > 0) {
          <p class="text-sm text-red-600 text-center">{{ errorMessage() }}</p>
        }

        <button
          type="submit"
          class="w-full h-11 rounded-lg bg-secondary text-secondary-foreground font-semibold cursor-pointer
                 hover:bg-secondary-hover transition-colors duration-150 disabled:opacity-60 disabled:cursor-not-allowed"
          [disabled]="!isRecoveryFormValid() || loading()"
        >
          @if (loading()) {
            Chargement…
          } @else if (view() === 'forgotPassword') {
            Envoyer le lien
          } @else {
            Envoyer le rappel
          }
        </button>

        <div class="text-center">
          <button type="button" class="cursor-pointer text-secondary text-sm font-medium hover:underline" (click)="setView('login')">
            Retour à la connexion
          </button>
        </div>
      </form>
    }

    @if (view() === 'login') {
      <p class="text-center text-sm text-[hsl(213_15%_46%)]">
        Pas encore de compte ?
        <a routerLink="/register" class="text-secondary font-medium hover:underline">S’inscrire gratuitement</a>
      </p>
    }
  </div>
</div>
